import { render, staticRenderFns } from "./cookie-banner-mspa-settings-card.vue?vue&type=template&id=1e74ca0a"
import script from "./cookie-banner-mspa-settings-card.vue?vue&type=script&lang=js"
export * from "./cookie-banner-mspa-settings-card.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports